import React, { useState, useCallback } from 'react';

import styles from './CampaignPictures.module.css';

const CampaignPictures = ({ parameters, panelPictures, campaignName }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageDimensions, setImageDimensions] = useState({});

    const handleImageLoad = (event, imageUrl) => {
        const { naturalWidth, naturalHeight } = event.target;
        setImageDimensions(prev => ({
            ...prev,
            [imageUrl]: { width: naturalWidth, height: naturalHeight }
        }));
    };

    const ImageModal = ({ image, onClose }) => (
        <div className={styles.modal} onClick={onClose}>
            <div className={styles.modalContent}>
                <img
                    src={image}
                    alt="Enlarged campaign view"
                    className={styles.modalImage}
                />
            </div>
        </div>
    );

    const fetchPicturesForZip = useCallback(async () => {
        if (!panelPictures || panelPictures.length === 0) {
            throw new Error('No pictures to download');
        }

        const pictureInfoList = panelPictures.map(picture => ({
            filename: picture.orgFileName,
            url: picture.storedAs
        }));

        // Get the blob from response
        return await ExportService.downloadPanelPictures(campaignName, pictureInfoList);
    }, [panelPictures, campaignName]);

    const handleExportError = (error) => {
        console.error('Failed to download campaign pictures:', error);
    };

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.imageContainer}>
                    {panelPictures?.map((picture, index) => {
                        const dimensions = imageDimensions[picture.storedAs] || {};
                        const isLandscape = dimensions.width > dimensions.height;

                        return (
                            <div
                                key={index}
                                className={styles.imageWrapper}
                                style={{
                                    height: isLandscape ? '300px' : '300px'
                                }}
                            >
                                <div
                                    className={styles.imageInner}
                                    onClick={() => setSelectedImage(picture.storedAs)}
                                >
                                    <img
                                        src={picture.storedAs}
                                        alt={`Campaign view ${index + 1}`}
                                        className={styles.image}
                                        onLoad={(e) => handleImageLoad(e, picture.storedAs)}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {selectedImage && (
                <ImageModal
                    image={selectedImage}
                    onClose={() => setSelectedImage(null)}
                />
            )}
        </div>
    );
};

export default CampaignPictures;